import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const ACCENT_COLORS = {
  sage:        { bg: '#1e3d32', light: '#e6f0e9', darkBg: '#0d1a14' },
  periwinkle:  { bg: '#2d2f7f', light: '#e5e6ff', darkBg: '#0e0f2e' },
  creamyRed:   { bg: '#7a1c1c', light: '#fbe9e7', darkBg: '#1a0808' },
  honeyYellow: { bg: '#6a4f1b', light: '#fff4db', darkBg: '#180f03' },
};

function applyVars(accent, isDark) {
  const colors = ACCENT_COLORS[accent] || ACCENT_COLORS.sage;
  document.documentElement.style.setProperty('--accent-bg',     colors.bg);
  document.documentElement.style.setProperty('--accent-light',  colors.light);
  document.documentElement.style.setProperty('--accent-text',   isDark ? colors.light : colors.bg);
  document.documentElement.style.setProperty('--surface-bg',    isDark ? colors.darkBg : colors.light);
  document.documentElement.style.setProperty('--surface-card',  isDark ? '#1c1c1c' : '#ffffff');
}

export const ThemeProvider = ({ children }) => {
  const [accent, setAccentState] = useState(
    () => localStorage.getItem('buddee-accent') || 'sage'
  );
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem('buddee-dark') === '1'
  );

  const setAccent = (newAccent) => {
    setAccentState(newAccent);
    localStorage.setItem('buddee-accent', newAccent);
  };

  const toggleDark = () => {
    setIsDark(prev => {
      const next = !prev;
      localStorage.setItem('buddee-dark', next ? '1' : '0');
      return next;
    });
  };

  // Re-apply all CSS vars whenever accent OR isDark changes
  useEffect(() => {
    applyVars(accent, isDark);
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [accent, isDark]);

  return (
    <ThemeContext.Provider value={{ accent, setAccent, isDark, toggleDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
export { ThemeContext };
